"use client";

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Grid, Button } from "@mui/material";
import { createElement } from "react";
import { ACCOUNTS_OPTIONS } from "../../../layouts/FullLayout/Sidebar/data";

export default function NavigationTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (href) =>
    location.pathname === href || location.pathname.startsWith(href + "/");

  const handleClick = (href) => navigate(href);

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      sx={{ py: { xs: 3, sm: 5 } }}
    >
      {ACCOUNTS_OPTIONS.map(({ title, icon, href }) => {
        const active = isActive(href);
        return (
          <Grid item key={href}>
            <Button
              variant="outlined"
              startIcon={icon ? createElement(icon) : null}
              onClick={() => handleClick(href)}
              sx={{
                textTransform: "none",
                borderRadius: 3,
                px: { xs: 2.5, sm: 3 },
                py: { xs: 1, sm: 1.2 },
                fontWeight: 600,
                fontSize: { xs: "0.85rem", sm: "0.95rem" },
                transition: "all .25s ease",
                border: active
                  ? "2px solid #56C662"
                  : "2px solid rgba(5,150,105,0.2)",
                bgcolor: active ? "linear-gradient(135deg,#56C662,#10b981)" : "#ffffff",
                color: active ? "white" : "#56C662",
                boxShadow: active
                  ? "0 3px 10px rgba(5,150,105,0.25)"
                  : "0 2px 6px rgba(0,0,0,0.05)",
                "&:hover": {
                  bgcolor: active
                    ? "linear-gradient(135deg,#047857,#56C662)"
                    : "#f0fdf4",
                  borderColor: "#56C662",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 14px rgba(5,150,105,0.25)",
                },
              }}
            >
              {title}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
}
